import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Constants from "../../utils/constants";
import apiClient from "../../services/apiClient";
import toast from "../../utils/toast";
import { getLocalData, setLocalData } from "../../services/storageManager";

const initialState = {
    selectedDept: false,
    loading: false,
    error: null,
}

export const getDepartments = (state)=>{
    let configList=JSON.parse(getLocalData('configList') || '{}');
    let departmentList=configList.map(value => {return { id: value.list.id, name: value.name, team: value.team.name, teamId: value.team.id}});
    return departmentList;
}

const departmentsSlice = createSlice({
    name: 'departments',
    initialState,
    reducers: {
        clearError(state, action) {
            state.error = null;
        },
        setCurrentDepartment(state, action) {
            state.selectedDept = action.payload;
            setLocalData('selectedDept', JSON.stringify(action.payload));
        }
    },
    extraReducers: (builder) => {
        /**Action--->get departments */
    }
})


export const { clearError, setCurrentDepartment } = departmentsSlice.actions;
export const getLoading = (state) => state.departments.loading;
export const getError = (state) => state.departments.error;
export const getSelectedDepartment = (state) => state?.departments?.selectedDept || JSON.parse(getLocalData('selectedDept') || '{}');

export default departmentsSlice.reducer;